import { Link, useNavigate } from "react-router-dom";
import { Project, PROJECT_STATUS_LABELS } from "../../models/project";
import { formatDate, formatMoney, statusPillClass } from "../../lib/projects";

export type AdminProject = Project & { owner_name: string | null };

type Props = {
  projects: AdminProject[];
};

export const AdminProjectsGrid = ({ projects }: Props) => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="hidden grid-cols-[2fr_1fr_1fr_1fr_1fr_1fr_1fr] items-center gap-4 border-b border-line pb-3 mb-5 text-sm text-neutral-500 md:grid">
        <span>Проєкт</span>
        <span>Передано</span>
        <span>Архітектор</span>
        <span className="text-center">Статус</span>
        <span className="text-center">Бонус</span>
        <span className="text-center">Сума</span>
        <span></span>
      </div>
      <div>
        {projects.map((p, idx) => (
          <div
            key={p.id}
            className={`cursor-pointer transition hover:opacity-90${idx > 0 ? " border-t border-line" : " pt-0"} py-4${idx === projects.length - 1 ? " pb-0" : ""}`}
            onClick={() => navigate(`/admin/projects/${p.id}`)}
          >
            <div className="grid grid-cols-[1fr_auto] items-start gap-x-4 gap-y-1 md:hidden">
              <div className="min-w-0">
                <span className="font-semibold text-white">{p.name}</span>
                <span className="mt-2 block text-xs text-neutral-400">
                  {formatDate(p.submitted_at)}
                </span>
                <span className="mt-0.5 block text-xs text-neutral-400">
                  <span className="text-neutral-500">Архітектор: </span>
                  {p.owner_name ?? "—"}
                </span>
                {p.client_name && (
                  <span className="block text-xs text-neutral-400">
                    <span className="text-neutral-500">Клієнт: </span>
                    {p.client_name}
                  </span>
                )}
              </div>
              <div className="flex flex-col items-end gap-1.5 min-h-full">
                <Link
                  to={`/admin/projects/${p.id}`}
                  className="link-brand mb-1 text-xs"
                  onClick={(e) => e.stopPropagation()}
                >
                  Деталі
                </Link>
                <div className="flex flex-col items-end gap-1 my-auto">
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${statusPillClass[p.status]}`}
                  >
                    {PROJECT_STATUS_LABELS[p.status]}
                  </span>
                  <span className="rounded-full bg-green-500/15 px-3 py-1 text-xs font-medium text-green-500">
                    Бонус: {formatMoney(p.bonus_amount)}
                  </span>
                </div>
              </div>
            </div>
            <div className="hidden md:grid md:grid-cols-[2fr_1fr_1fr_1fr_1fr_1fr_1fr] md:items-center md:gap-4">
              <span className="min-w-0 truncate font-semibold text-white">
                {p.name}
              </span>
              <span className="text-neutral-300">{formatDate(p.submitted_at)}</span>
              <span className="min-w-0 truncate text-neutral-300">
                {p.owner_name ?? "—"}
              </span>
              <span
                className={`justify-self-center rounded-full px-3 py-1 text-xs font-medium ${statusPillClass[p.status]}`}
              >
                {PROJECT_STATUS_LABELS[p.status]}
              </span>
              <span className="text-center text-neutral-200">
                {formatMoney(p.bonus_amount)}
              </span>
              <span className="text-center text-neutral-200">
                {formatMoney(p.contract_amount)}
              </span>
              <Link
                to={`/admin/projects/${p.id}`}
                className="link-brand justify-self-end px-2"
                onClick={(e) => e.stopPropagation()}
              >
                Деталі
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
